<template>
    <ul class="uk-pagination" role="navigation" v-if="total_pages > 1 || ! hideIfSinglePage">
        <li :class="current_page <= 1 ? 'uk-disabled' : ''">
          <a @click="setPage(1)" class="pagination-button-first"></a>
        </li>
        <li :class="current_page <= 1 ? 'uk-disabled' : ''">
            <a @click="setPage(current_page -1)" class="pagination-button-prev"></a>
        </li>
        <li>
          {{ current_page }} / {{ total_pages }}
        </li>
        <li :class="current_page >= total_pages ? 'uk-disabled' : ''">
            <a @click="setPage(current_page + 1)" class="pagination-button-next"></a>
        </li>
        <li :class="current_page >= total_pages ? 'uk-disabled' : ''">
          <a @click="setPage(total_pages)" class="pagination-button-last"></a>
        </li>
    </ul>
</template>
<script>
  import DataGridPaginator from 'js/theme-mixins/DataGridPaginator';

  export default {
    mixins: [DataGridPaginator],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/assets/js/theme-components/grid/DataGridPaginator.vue